import { useEffect } from 'react';
export const KeyPressListener = ({ code, handler, keyEvent = 'keyup', disabled = false, }) => {
    const handleKeyEvent = (event) => {
        if (disabled) {
            event.preventDefault();
            return;
        }
        if (event.code === code) {
            handler(event);
        }
    };
    useEffect(() => {
        document.addEventListener(keyEvent, handleKeyEvent);
        return () => {
            document.removeEventListener(keyEvent, handleKeyEvent);
        };
    });
    return null;
};
//# sourceMappingURL=KeyPressListener.js.map